export const usersFilterState = () => ({
  searchKey: '',
  page: 1,
  perPage: 10,
  orderBy: 'createdAt',
  order: 'desc'
});
